import React from "react";
import styles from "../../../../styles/scope3/Dashboard/transportation.module.css";
import { Box, Typography } from "@mui/material";
import EchartDoughnutChart from "../../../../Components/GraphNCharts/EchartDoughnut";
import { formatNumberCommaSeparated } from "../../../../utils/common";

const FuelConsumption = ({ data }) => {
  return (
    <div className={styles.cards} style={{ width: "100%" }}>
      <div style={{ width: "82%" }}>
        <p className={styles.emission_heading}>
          Total Trips : {"  "}
          {/* </p> */}
          <span className={styles.emission_heading_span}>
            {formatNumberCommaSeparated(data?.sumOfTrip ?? 0)}
            {/* (+10% YOY <TrendingUpIcon sx={{ fontSize: "18px" }} />) */}
          </span>
        </p>
      </div>
      {data?.tripsByType?.map((el) => el?.totalTrips)?.filter(Boolean)?.length >
      0 ? (
        <Box sx={{ display: "flex", gap: 1, mt: 4 }}>
          <Box sx={{ width: "80%", ml: "-1.5rem" }}>
            <EchartDoughnutChart
              labels={data?.tripsByType?.map((el) => el?.transportationType)}
              dataPoints={data?.tripsByType?.map((el) => el?.totalTrips)}
              colors={data?.tripsByType?.map((el) =>
                el?.transportationType === "Upstream" ? "#FF4F4F" : "#0E62E0"
              )}
              customWidth={280}
              customHeight={250}
              hide={true}
            />
          </Box>
          <div style={{ marginTop: "25%", width: "50%" }}>
            {data?.tripsByType?.map((item, index) => (
              <div key={index} className={styles.table_container}>
                <div className={styles.table_row}>
                  <span
                    className={styles.table_row_label}
                    style={{
                      backgroundColor:
                        item?.transportationType === "Upstream"
                          ? "#FF4F4F"
                          : "#0E62E0",
                    }}
                  ></span>
                  <span className={styles.table_text}>
                    {item.transportationType}
                  </span>
                </div>
                <span className={styles.table_text}>
                  {formatNumberCommaSeparated(item?.totalTrips ?? 0)}
                </span>
              </div>
            ))}
          </div>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // horizontally center
            alignItems: "center", // vertically center
            height: "18rem", // ensure it takes up space
            width: "100%", // optional, to match parent
          }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "inter",
              color: "#d3d3d3",
              fontWeight: "bold",
            }}
          >
            No Data Found
          </Typography>
        </Box>
      )}
    </div>
  );
};

export default FuelConsumption;
